import { enableProdMode } from '@angular/core';
import { appConfig } from './app/app.config';
import { environment } from '@environment';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { CognitoStorageService } from '@commons/services/cognito-storage/cognito-storage.service';

if (environment.production) {
  enableProdMode();
}

// Restore session from cross-subdomain cookies into localStorage before bootstrapping Angular
CognitoStorageService.syncFromCookies();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
